import { isSessionMessage } from "../module";
import { UpdateFacetOnModelMessage, MetaDataFacet, RemoveSubModelMessage, RemoveFacetFromModelMessage } from "flavr-common";
export class InteractionMetaDataManager {
    constructor(connection) {
        this.connection = connection;
        this.mataDataForModels = new Map();
        this.mataDataByType = new Map();
        // MetaDataType -> CallbackName -> Callback
        this.metaDataUpdateCallbacks = new Map();
        connection.subscribe([
            UpdateFacetOnModelMessage.typestatic + MetaDataFacet.typestatic,
            RemoveFacetFromModelMessage.typestatic + MetaDataFacet.typestatic,
            RemoveSubModelMessage.typestatic
        ], (msg, meta) => {
            this.handleMessage(msg, meta);
        });
    }
    getMetaDataForModel(uid) {
        return this.mataDataForModels.get(uid);
    }
    getMetaDataOfType(type) {
        return this.mataDataByType.get(type.typestatic);
    }
    getMetaData(uid, type) {
        const mataDataOfType = this.getMetaDataOfType(type);
        const entry = mataDataOfType ? mataDataOfType.get(uid) : undefined;
        return entry ? entry.data : undefined;
    }
    setMetaDataForModel(uid, metaData, timeStamp, executeCallbacks = false) {
        this.connection.send(new UpdateFacetOnModelMessage(uid, new MetaDataFacet(metaData)));
        this.updateMetaData(uid, metaData, timeStamp, executeCallbacks);
    }
    addUpdateCallback(group, type, callback) {
        let callbacks = this.metaDataUpdateCallbacks.get(type.typestatic);
        if (!callbacks) {
            callbacks = new Map();
            this.metaDataUpdateCallbacks.set(type.typestatic, callbacks);
        }
        callbacks.set(group, callback);
    }
    removeUpdateCallbacks(group) {
        for (const [type, callbacks] of this.metaDataUpdateCallbacks) {
            callbacks.delete(group);
            if (callbacks.size === 0) {
                this.metaDataUpdateCallbacks.delete(type);
            }
        }
    }
    removeMetaDataFromModel(uid) {
        const mataDataForModel = this.mataDataForModels.get(uid);
        if (mataDataForModel) {
            for (const type of mataDataForModel.keys()) {
                this.connection.send(new RemoveFacetFromModelMessage(uid, MetaDataFacet, type));
                this.removeMetaData(uid, type);
            }
        }
    }
    handleMessage(msg, meta) {
        if (UpdateFacetOnModelMessage.is(msg)) {
            if (MetaDataFacet.is(msg.facet)) {
                this.updateMetaData(msg.uid, msg.facet.data, meta.timeStamp, true, isSessionMessage(meta));
            }
        }
        else if (RemoveFacetFromModelMessage.is(msg)) {
            if (msg.facetType === MetaDataFacet.typestatic && msg.subtype !== undefined) {
                this.removeMetaData(msg.uid, msg.subtype, meta.timeStamp, isSessionMessage(meta));
            }
        }
        else if (RemoveSubModelMessage.is(msg)) {
            const mataDataForModel = this.mataDataForModels.get(msg.uid);
            if (mataDataForModel) {
                for (const type of mataDataForModel.keys()) {
                    this.removeMetaData(msg.uid, type, meta.timeStamp, isSessionMessage(meta));
                }
            }
        }
    }
    updateMetaData(uid, metaData, timeStamp, executeCallbacks, isSessionMessage) {
        let mataDataForModel = this.mataDataForModels.get(uid);
        if (!mataDataForModel) {
            mataDataForModel = new Map();
            this.mataDataForModels.set(uid, mataDataForModel);
        }
        const entry = {
            data: metaData,
            timeStamp
        };
        const oldMetaData = mataDataForModel.get(metaData.type);
        mataDataForModel.set(metaData.type, entry);
        let mataDataOfType = this.mataDataByType.get(metaData.type);
        if (!mataDataOfType) {
            mataDataOfType = new Map();
            this.mataDataByType.set(metaData.type, mataDataOfType);
        }
        mataDataOfType.set(uid, entry);
        if (executeCallbacks) {
            const callbacks = this.metaDataUpdateCallbacks.get(metaData.type);
            if (callbacks) {
                for (const callback of callbacks.values()) {
                    callback(uid, metaData, oldMetaData, isSessionMessage);
                }
            }
        }
    }
    removeMetaData(uid, metaDataType, timeStamp, isSessionMessage) {
        const mataDataForModel = this.mataDataForModels.get(uid);
        if (!mataDataForModel)
            return;
        const oldMetaData = mataDataForModel.get(metaDataType);
        if (oldMetaData) {
            if (timeStamp !== undefined && oldMetaData.timeStamp >= timeStamp)
                return;
            const callbacks = this.metaDataUpdateCallbacks.get(metaDataType);
            if (callbacks) {
                for (const callback of callbacks.values()) {
                    callback(uid, undefined, oldMetaData.data, isSessionMessage);
                }
            }
            const mataDataOfType = this.mataDataByType.get(metaDataType);
            if (mataDataOfType) {
                mataDataOfType.delete(uid);
                if (mataDataOfType.size === 0)
                    this.mataDataByType.delete(metaDataType);
            }
        }
        if (mataDataForModel.size === 0) {
            this.mataDataForModels.delete(uid);
        }
    }
}
